import "./index.css";
import ProdDeliveriesTable from "./Table";

const ProdDeliveriesContents = ({ productId }) => {
  return (
    <div className="prod-component-contents">
      <ProdDeliveriesTable productId={productId} />
    </div>
  );
};

export default ProdDeliveriesContents;
